export default {
  install(Vue) {
    Vue.prototype.$goBack = function goBack() {
      this.$router.go(-1);
    };

    Vue.prototype.$toggleItemPreenchidoBarraProgresso = function (
      item,
      shouldAdd,
      itemsPreenchidos = []
    ) {
      if (!Array.isArray(itemsPreenchidos)) {
        return shouldAdd ? [item] : [];
      }
      const add =
        Boolean(shouldAdd) &&
        !(typeof shouldAdd === "object" && shouldAdd.descricao === "Escolha um horario");

      const index = itemsPreenchidos.indexOf(item);

      if (add && index === -1) {
        itemsPreenchidos.push(item);
      } else if (!add && index > -1) {
        itemsPreenchidos.splice(index, 1);
      }

      return itemsPreenchidos;
    };

    Vue.prototype.$checkTotallyFilled = function (
      isTotalFilled,
      propriedade = "totalmentePreenchido"
    ) {
      this[propriedade] = isTotalFilled;
      return isTotalFilled;
    };
  },
};
